import { themes } from '@/plugins/vuetify/theme'

type CalendarEntity = 'audits' | 'adverseEvents' | 'tickets' | 'appointments' | 'improvements' | 'default'

const entityAliases: Record<string, CalendarEntity> = {
  'аудиты': 'audits',
  'нежелательные события': 'adverseEvents',
  'заявки': 'tickets',
  'заявка': 'tickets',
  'тикеты': 'tickets',
  'записи': 'appointments',
  'задачи': 'appointments',
  'задача': 'appointments',
  'предложения по улучшению': 'improvements',
  'ппу': 'improvements',
}

const entityColors: Record<'light' | 'dark', Record<CalendarEntity, string>> = {
  light: {
    audits: '#0F6F73',
    adverseEvents: '#B4232B',
    tickets: '#267A3E',
    appointments: '#4255A8',
    improvements: '#C67C00',
    default: '#5B6472',
  },
  dark: {
    audits: '#62D3D7',
    adverseEvents: '#FF8A91',
    tickets: '#79D99A',
    appointments: '#AAB7FF',
    improvements: '#FFB400',
    default: '#C5CCD6',
  },
}

export const getCalendarEntityColor = (entityLabel: string | undefined, isDark: boolean): string => {
  const entity = entityAliases[entityLabel?.trim().toLocaleLowerCase('ru-RU') ?? ''] ?? 'default'

  return entityColors[isDark ? 'dark' : 'light'][entity]
}

const themeInfoColor = (mode: 'light' | 'dark') =>
  themes[mode].colors?.info as string

/* Подтипы аудита: используются только в графике проверок */
const auditTypeColors: Record<'light' | 'dark', Record<string, string>> = {
  light: {
    planned: '#0F6F73',
    unplanned: themeInfoColor('light'),
    overdue: '#B4232B',
  },
  dark: {
    planned: '#62D3D7',
    unplanned: themeInfoColor('dark'),
    overdue: '#FF8A91',
  },
}

export const getAuditTypeColor = (auditType: string | undefined, isDark: boolean): string => {
  const palette = auditTypeColors[isDark ? 'dark' : 'light']

  return (auditType && palette[auditType]) || getCalendarEntityColor('Аудиты', isDark)
}
